export interface PasswordRuleChecks {
  minLength: boolean;
  hasUppercase: boolean;
  hasLowercase: boolean;
  hasDigit: boolean;
  hasSpecial: boolean;
}

export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 128;

export const PASSWORD_POLICY_ERROR_MESSAGE =
  "Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one digit and one special character";

export function evaluatePasswordRules(password: string): PasswordRuleChecks {
  return {
    minLength: password.length >= PASSWORD_MIN_LENGTH,
    hasUppercase: /[A-Z]/.test(password),
    hasLowercase: /[a-z]/.test(password),
    hasDigit: /[0-9]/.test(password),
    hasSpecial: /[^A-Za-z0-9]/.test(password),
  };
}

export function isPasswordValid(checks: PasswordRuleChecks): boolean {
  return Object.values(checks).every(Boolean);
}

export function isValidPassword(password: string): boolean {
  return password.length <= PASSWORD_MAX_LENGTH && isPasswordValid(evaluatePasswordRules(password));
}

export function generatePasswordChecklistLabels(): {
  id: string;
  label: string;
}[] {
  return [
    { id: "minLength", label: "8+ characters" },
    { id: "hasUppercase", label: "Uppercase" },
    { id: "hasLowercase", label: "Lowercase" },
    { id: "hasDigit", label: "Number" },
    { id: "hasSpecial", label: "Special character" },
  ];
}